import ShopaholicProductList from '@lovata/shopaholic-product-list/shopaholic-product-list';
import ShopaholicPagination from '@lovata/shopaholic-product-list/shopaholic-pagination';
import ShopaholicSorting from '@lovata/shopaholic-product-list/shopaholic-sorting';
import ShopaholicFilterPanel from '@lovata/shopaholic-filter-panel/shopaholic-filter-panel';
import ShopaholicFilterPrice from '@lovata/shopaholic-filter-panel/shopaholic-filter-price';
import ShopaholicSearch from '@lovata/shopaholic-search';

export default new class listComponent {
  constructor() {
    this.searchWrapper = '._search-result';
    this.filterWrapper = '_filter_wrapper';
    this.brandWrapperSelector = '._shopaholic-brand-filter-wrapper';
    this.linkFilterSelector = 'fieldset';
    this.activeLinkFilterSelector = 'open';
    this.filterSelector = 'fieldset-options';
    this.invisibleFilterSelector = 'filter-hidden';
    this.filterBarSelector = '.list-product';
    this.obShopaholicProductList = new ShopaholicProductList();
    this.init();
    this.initSearch();
  }

  init() {
    this.productList();
    this.openMobileFilter();
    this.initCloseFilter();
    this.filterSelected();
  }

  openMobileFilter() {
    $(document)
      .on('click', '._open-filter', () => {
        this.toggleMobileFilter();
      });
  }

  initCloseFilter() {
    $(document)
      .on('click', '._filter-close', () => {
        this.toggleMobileFilter();
      });
  }

  toggleMobileFilter() {
    $(`.${this.filterWrapper}`).toggleClass('open-filter');
  }

  closeMobileFilter() {
    $(`.${this.filterWrapper}`).removeClass('open-filter');
  }

  filterSelected() {
    $(document)
      .on('click', `.${this.linkFilterSelector}`, (e) => {
        e.preventDefault();

        const { target } = e;
        if ($(target)
          .hasClass(this.activeLinkFilterSelector)) {
          this.hideTab();
          return;
        }

        this.showTab(target);
      });
  }

  hideTab() {
    const tabCollection = $(`.${this.linkFilterSelector}`);
    const tabFilterCollection = $(`.${this.filterSelector}`);

    [...tabCollection].forEach(tab => $(tab)
      .removeClass(this.activeLinkFilterSelector));
    [...tabFilterCollection].forEach(el => $(el)
      .addClass(this.invisibleFilterSelector));
  }

  showTab(target) {
    const id = $(target)
      .attr('href');
    const tabContent = $(id);

    this.hideTab();

    $(target)
      .addClass(this.activeLinkFilterSelector);

    tabContent.removeClass(this.invisibleFilterSelector);
  }

  productList() {
    this.obShopaholicProductList.setAjaxRequestCallback((obRequestData) => {
      // eslint-disable-next-line no-param-reassign
      obRequestData.update = {
        'catalog/category/ajax': '._catalog_wrapper',
        'catalog/category/filters': '._filter_wrapper',
      };
      // eslint-disable-next-line no-param-reassign
      obRequestData.complete = () => {
        this.closeMobileFilter();
        this.hideTab();

        const bar = $(this.filterBarSelector);
        if (!bar.length) return;
        const distance = bar.offset().top;
        $('body, html').animate({ scrollTop: distance }, 450);
      };
      return obRequestData;
    });

    const obPaginationHelper = new ShopaholicPagination(this.obShopaholicProductList);
    obPaginationHelper.init();

    const obSortingHelper = new ShopaholicSorting(this.obShopaholicProductList);
    obSortingHelper.init();

    const obFilterPanel = new ShopaholicFilterPanel(this.obShopaholicProductList);
    obFilterPanel.init();

    const obBrandFilterPanel = new ShopaholicFilterPanel(this.obShopaholicProductList);
    obBrandFilterPanel
      .setWrapperSelector(this.brandWrapperSelector)
      .setFieldName('brand')
      .init();

    const obFilterPrice = new ShopaholicFilterPrice(this.obShopaholicProductList);
    obFilterPrice.setEventType('input').init();
  }

  initSearch() {
    const obHelper = new ShopaholicSearch();
    obHelper.setSearchLimit(2).setAjaxRequestCallback((obRequestData) => {
      // eslint-disable-next-line no-param-reassign
      obRequestData.loading = '.preloader';
      // eslint-disable-next-line no-param-reassign
      obRequestData.update = { 'catalog/search/search-result': this.searchWrapper };
      $(this.searchWrapper).addClass('open-search');
      $(this.searchWrapper).show();
      $('._search-icon').fadeOut();
      $('._search-close').fadeIn();
      $('body, html').animate({ scrollTop: 300 }, 450);
      return obRequestData;
    }).init();
  }
}();
